import { useQuery } from '@tanstack/react-query'

import {
  fetchProposal,
  fetchProposals,
  fetchProposalVotes,
  fetchVoterVote,
  ProposalsParams,
} from '@/api'
import { queryKeys } from '@/queries/keys'
import { PaginationParams } from '@/types'

export function useProposals(params?: ProposalsParams) {
  return useQuery({
    queryKey: queryKeys.governance.proposals(
      params?.proposal_status,
      params?.voter,
      params?.depositor,
      params?.pagination,
    ),
    queryFn: () => fetchProposals(params),
  })
}

export function useProposal(proposalId?: string) {
  return useQuery({
    queryKey: queryKeys.governance.proposal(proposalId),
    queryFn: () => {
      if (!proposalId) throw new Error('Proposal ID is required')
      return fetchProposal(proposalId)
    },
    enabled: Boolean(proposalId),
  })
}

export function useProposalVotes(
  proposalId?: string,
  pagination?: PaginationParams,
) {
  return useQuery({
    queryKey: queryKeys.governance.votes(proposalId, pagination),
    queryFn: () => {
      if (!proposalId) throw new Error('Proposal ID is required')
      return fetchProposalVotes(proposalId, pagination)
    },
    enabled: Boolean(proposalId),
  })
}

export function useVoterVote(proposalId?: string, voter?: string) {
  return useQuery({
    queryKey: queryKeys.governance.vote(proposalId, voter),
    queryFn: () => {
      if (!proposalId) throw new Error('Proposal ID is required')
      if (!voter) throw new Error('Voter address is required')
      return fetchVoterVote(proposalId, voter)
    },
    enabled: Boolean(proposalId) && Boolean(voter),
  })
}
